import * as types from "./types";
import { combineReducers } from "redux";

function listadoCobros(state = [], action) {
  switch (action.type) {
    case types.FETCH_LISTADO:
      return action.payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
}

function actividadSeleccionada(state = null, action) {
  switch (action.type) {
    case types.PUT_ACTIVIDAD_SELECCIONADA:
      return action.payload;

    case types.CLEAR_ACTIVIDAD_SELECCIONADA:
      return null;

    default:
      return state;
  }
}


const reducer = combineReducers({
  listadoCobros,
  actividadSeleccionada
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/cobros/reducers.js